var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
    [
      _c(
        "w-col",
        { staticClass: "parent", attrs: { xs: "12" } },
        [
          _vm.isFetching ? _c("app-fetching-spinner-overlay") : _vm._e(),
          _c("w-data-table", {
            staticClass: "ticket-table",
            attrs: {
              "empty-label": "Geen data gevonden",
              items: _vm.tickets,
              columns: _vm.columns,
              "selected-items": _vm.selected,
              "order-column": _vm.orderedColumnProperty,
              "order-direction": _vm.orderAscending,
            },
            on: {
              order: function ($event) {
                return _vm.onOrder($event)
              },
              "item-clicked": function ($event) {
                return _vm.openTicket($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }